import { IDriveViewSearchResult } from '@commenda/types/src/drive-view/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

export interface ISearchDocumentsResponse {
  results: IDriveViewSearchResult[];
  count: number;
}

export function useSearchDocuments(
  companyId: number | null,
  query: string
) {
  const url =
    companyId != null && query.trim().length > 0
      ? `drive-view/search?companyId=${companyId}&query=${encodeURIComponent(query.trim())}`
      : null;

  const { data, error, isLoading } = useSWR<ISearchDocumentsResponse>(
    url,
    SWRFetcher({ method: 'GET' }),
    // The CompanySearchBar already debounces the input (300ms). We want
    // every debounced query to actually hit the server — disable SWR's
    // request deduping so that identical keys still trigger a network
    // call rather than reading from cache.
    { dedupingInterval: 0 }
  );

  return { data, error, isLoading };
}
